<template>
	<div class="KickingballScreen">
		<SectionWrapper class="Cover" :backgroundImage="require(`@/assets/imgs/main/photo-11.webp`)" :imageOpacity="0.3">
			<iframe class="Video"
				src="https://www.youtube.com/embed/QVgU08KuQZ8?controls=0&modestbranding=1&rel=0&showinfo=0" frameborder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen />
			<!-- &playsinline=1&iv_load_policy=3&fs=0 -->

		</SectionWrapper>

		<div class="Wrapper">
			<SectionWrapper title="Kickingball" :useGradientBackground="false">
				<p>
					El kickingball es un deporte de equipo que combina estrategia, velocidad y precisión. Se juega en un
					campo similar al de béisbol o sóftbol, con tres bases, un home plate y un balón parecido al de fútbol.
				</p>
			</SectionWrapper>

			<SectionWrapper title="Cómo se juega" :useGradientBackground="false">
				<p>
					Dos equipos de 10 jugadoras se enfrentan durante 9 innings. La pitcher hace rodar el balón hacia el
					cajón de pateo y la pateadora debe impulsarlo con el pie para avanzar por las bases e intentar anotar
					carreras antes de ser eliminada.
				</p>

				<div class="Picture" :style="{ backgroundImage: `url(${require(`@/assets/imgs/main/photo-42.webp`)})` }">
				</div>

				<p>
					El equipo defensor busca detener la jugada realizando outs y evitando el avance de las corredoras,
					mientras que el equipo atacante intenta sumar la mayor cantidad de carreras posible. Gana el equipo que
					más carreras anote al finalizar el partido.
					<br><br>
					👉 Consulta el reglamento para conocer todas las reglas del juego.
				</p>

				<a class="Reglamento" href="https://drive.google.com/file/d/1_WuVeXRZ9Fc6D76YCqyJH8WIuaee-sKr/view"
					target="_blank">
					<Icon icon="file-text" :size="20" color="white" />
					<p>Ver reglamento</p>
				</a>
			</SectionWrapper>

			<SectionWrapper title="Cual es su origen" :useGradientBackground="false">
				<p>
					El kickingball tiene sus raíces en Estados Unidos, donde nació el kickball, una actividad recreativa
					inspirada en el béisbol que sustituía el bate por el golpeo del balón con el pie.
					<br><br>
					El kickball se popularizó en colegios y campamentos por su sencillez y por requerir pocos materiales. En
					algunos colegios españoles también se practica una variante similar conocida como “pichi”.
				</p>
				<div class="PictureWrapper">

					<div class="Picture small"
						:style="{ backgroundImage: `url(${require(`@/assets/imgs/main/kickball.gif`)})` }">
					</div>
				</div>

				<p>
					Con el paso del tiempo, esta práctica evolucionó especialmente en Venezuela, donde el deporte desarrolló
					reglas, posiciones, competiciones y una identidad propia hasta convertirse en el kickingball que se
					conoce hoy: una disciplina más técnica y competitiva que el kickball recreativo del que proviene.
				</p>
			</SectionWrapper>
			<SectionWrapper title="Dónde se juega" :useGradientBackground="false">
				<p>
					Actualmente, además de en Venezuela, el kickingball se practica en distintos países y continúa creciendo
					gracias a comunidades migrantes venezolanas que han impulsado el deporte tanto de forma amateur como
					competitiva.
					<br><br>
					En España, Tenerife fue el primer lugar donde comenzó a jugarse. En 2015, le siguió Madrid con la
					creación de Espartanas, el primer equipo de la ciudad.
				</p>
			</SectionWrapper>
		</div>
		<SectionWrapper title="Equipos en España" description="Descubre los equipos que hacen crecer el kickingball en España.
Haz clic en cada nombre para visitar su Instagram." :backgroundImage="require(`@/assets/imgs/main/photo-12.webp`)"
			:imageOpacity="0.6">
			<div class="TeamsList">
				<ul v-for="(city, cityName) in teams" :key="cityName" class="City" :style="{ 'grid-area': cityName }">
					<li>
						<div class="Team">
							<div class="Name">
								<p>{{ cityName }}</p>
							</div>
						</div>
					</li>
					<li v-for="({ name, IG: instagramId, createdAt, inactive }, index) in city" :key="index"
						@click="goTo(instagramId)">
						<div class="Line" />
						<div class="Team" :class="{ inactive }">
							<div class="Name">
								<p>{{ name }}</p>
							</div>
							<span>{{ createdAt }}</span>
						</div>
					</li>
				</ul>
			</div>
		</SectionWrapper>
	</div>
</template>

<script>
import { mediaQueryMixin } from "@/mixins";
import { teams } from '@/data/teams.js'
import { SplideWrapper, SectionWrapper } from '@/components'

export default {
	name: 'KickingballScreen',
	components: {
		SplideWrapper,
		SectionWrapper
	},
	mixins: [mediaQueryMixin],
	data() {
		return {
			teams,
		}
	},
	methods: {
		goTo(instagramId) {
			if (instagramId) window.open(`https://www.instagram.com/${instagramId}`, '_blank')
		},
	},
	computed: {}
}

</script>

<style lang="scss" scoped>
* {
	transition: all .4s
}

.KickingballScreen {
	width: 100%;
	background: #333;

	@media screen and (min-width: $xl) {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.Cover {
		position: absolute;
		height: 22rem;
		width: 100%;
		top: 0;
		left: 0;

		@media screen and (max-width: $sm) {
			height: 16rem;
		}

		.Video {
			z-index: 10;
			// width: 20rem;
			// height: 12rem;
			border-radius: 20px;
			border: 5px solid rgba(white, .1);
			box-shadow: 0 2px 5px 0 rgba(black, 0.1);
			margin-top: 8rem;

			@media screen and (max-width: $sm) {
				width: 100%;
				margin-top: 8rem;
				min-height: 11rem;
			}
		}
	}

	.Wrapper {
		margin-top: 24rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;

		@media screen and (min-width: $xl) {
			width: 1300px;
		}

		@media screen and (max-width: $sm) {
			margin-top: 22rem;
		}

		.PictureWrapper {
			display: flex;
			gap: 1rem;
			width: 50%;

			@media screen and (max-width: $sm) {
				width: 100%;
			}
		}

		.Picture {
			width: 100%;
			flex: 1;
			height: 15rem;
			border-radius: 20px;
			margin: 2rem 0;
			background-size: cover;
			background-repeat: no-repeat;
			background-position-x: center;
			background-position-y: center;

			&.small {
				width: 50%;
				height: 18rem;

				@media screen and (max-width: $sm) {
					// height: 10rem;
				}
			}

			@media screen and (max-width: $sm) {
				height: 10rem;
			}
		}

		.Reglamento {
			width: fit-content;
			margin-top: 2rem;
			border-radius: 1rem;
			border: 5px solid rgba(white, .1);
			box-shadow: 0 2px 5px 0 rgba(black, 0.1);
			background: rgba(white, .1);
			padding: 8px 25px;
			display: flex;
			align-items: center;

			.Icon {
				margin-right: 1rem
			}

			p {
				font-size: 1.2rem
			}
		}

		p {
			width: 100%;
			font-size: 1rem;
			// text-align: justify;
			line-height: 2rem;
			color: white;

			@media screen and (max-width: $md) {
				font-size: 1.1rem;
				line-height: 1.8rem;
			}
		}

	}

	.TeamsList {
		width: 100%;
		min-height: fit-content;
		height: 100%;
		display: grid;
		grid-column-gap: 50px;
		grid-row-gap: 50px;
		grid-template-columns: repeat(3, 1fr);
		// grid-template-rows: 1fr;
		grid-template-rows: auto;
		grid-template-areas:
			"BARCELONA MADRID TENERIFE"
			"ZARAGOZA MADRID VALENCIA"
			"BILBAO MADRID GRANCANARIA";


		@media screen and (max-width: $md) {
			grid-template-columns: repeat(2, 1fr);
			grid-template-areas:
				"MADRID GRANCANARIA"
				"MADRID VALENCIA"
				"MADRID ZARAGOZA"
				"MADRID BILBAO"
				"MADRID TENERIFE"
				"BARCELONA TENERIFE";
		}


		ul {
			margin: 0;
			padding: 0;

			li {
				display: flex;
				flex-direction: column;
				align-items: center;
				list-style: none;

				.Team {
					display: flex;
					flex-direction: column;
					align-items: center;
					cursor: pointer;



					.Name {
						background: white;
						width: fit-content;
						padding: 12px 25px 15px 25px;
						border-radius: 20px;


						// transform: scale(1.1);
						font-weight: bold;

						@media screen and (max-width: $sm) {
							padding: 10px 20px 10px 20px;
						}
					}

					&.inactive {
						// opacity: .8;
						// cursor: default !important;


						.Name {
							transform: none !important;
							background: #888;
						}

						// p {
						// color: $gray-dark;
						// }
						span {
							color: #888;
						}
					}

					p {
						color: $gray-dark;
						font-size: 18px;
						line-height: 18px;
						margin: 0;
						padding: 0;
						text-align: center;

						@media screen and (max-width: $sm) {
							font-size: 16px;
							line-height: 16px;
						}
					}

					// span {
					// 	padding: 10px 0;
					// 	color: white;
					// }
					span {
						color: white;
						font-weight: regular;
						padding: 0;
						height: 0;
						visibility: hidden;
						opacity: 0;
						// transition: opacity .1s, visibility .4s, height .4s, padding .4s;

						visibility: visible;
						height: auto;
						padding: 6px 0 10px 0;
						opacity: 1;
					}

					&:hover {
						.Name {
							transform: scale(1.1);
							font-weight: bold;
						}

						span {
							visibility: visible;
							height: auto;
							// padding: 10px 0;
							opacity: 1;
						}
					}
				}

				.Line {
					width: 2px;
					height: 20px;
					background: white;
				}

				&:first-child {
					cursor: default;

					.Team:hover .Name {
						transform: none;
					}

					.Name {
						padding: 15px 30px 18px 30px;
						background-image: linear-gradient(45deg, $primary, $info);

						@media screen and (max-width: $sm) {
							padding: 12px 20px 15px 20px;
						}

						p {
							color: white;
							font-weight: bold;
						}
					}
				}
			}
		}
	}
}
</style>
